export const PORTFOLIO_MARGIN_MINIMUM_EQUITY = 10000;
